import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'

import type { GetAffiliateDashboardResponse } from './get-affiliate-dashboard.types'

const getAffiliateDashboard =
  async (): Promise<GetAffiliateDashboardResponse> => {
    const response = await apiClient.get<GetAffiliateDashboardResponse>(
      '/v1/affiliation/dashboard',
    )
    return response.data
  }

interface UseGetAffiliateDashboardOptions {
  // Blocked/managed accounts must not even hit the endpoint (every
  // affiliation endpoint rejects them); the page gates with this flag.
  enabled?: boolean
}

export const useGetAffiliateDashboard = (
  options?: UseGetAffiliateDashboardOptions,
) => {
  return useQuery({
    queryKey: ['affiliate-dashboard'],
    queryFn: () => getAffiliateDashboard(),
    enabled: options?.enabled ?? true,
    // Every page of the affiliate section gates on this read, so the app-wide
    // zero-cache default made moving between the pages replay the page
    // skeleton each time. Staleness is safe here: the mutations that change
    // any of it already invalidate ['affiliate-dashboard'] by key.
    staleTime: 1000 * 30, // 30s - a page hop must not refetch the gate
    // Without a gcTime of its own the cached entry is dropped the moment the
    // last page unmounts, which puts the refetch (and the skeleton) straight
    // back — staleTime alone cannot fix the flash.
    gcTime: 1000 * 60 * 5, // 5min - survive navigating away and back
  })
}
